export default "__VITE_ASSET__5afb9b26__"